import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import ProductCard from '../../ProductCard';
import { useCart } from '../../../hooks/useCart';
import Glide from '@glidejs/glide';
import IconBackArrow from '../../svgs/BackArrow'
import IconForwardArrow from '../../svgs/ForwardArrow'

interface CartRecomendationsProps {
  dataSet: {
    productId: number;
    baseUrl: string;
    limit: number;
    title: string;
    fromText: string;
    colourSwatches: string;
    roastText: string;
    tasteText: string;
    quickAddText: string;
    quickAddPlus: string
  }
}

const CartRecommendations = (props: CartRecomendationsProps): JSX.Element => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { cart } = useCart();
  const { dataSet: { baseUrl, productId, limit, title, fromText, colourSwatches, roastText, tasteText, quickAddText, quickAddPlus } } = props;
  const upsellProducts = window['theme'].cart_upsells;
  const glideEl = useRef();
  const glideOptions = { 
    type: 'carousel',
    startAt: 0,
    perView: 3.2,
    perTouch: false,
    touchRatio: 0.5,
    dragThreshold: 50,
    rewind: false,
    gap: 0,
    throttle: 50,
    peek: {
      before: -24,
      after: 0
    },
    breakpoints: {
      '1440': {
        perView: 3.2
      },
      '768': {
        perView: 1.05,
        perTouch: 1,
        peek: {
          before:0,
          after: 0
        }
      },
    },
  }
  
  useEffect(() => {
    // Get more upsells if we don't have enough
    if (upsellProducts.length < limit) {
      axios.get(`${baseUrl}.json?product_id=${productId}&limit=${limit}`)
        .then((res) => {
          const d = res.data;
          if (d && d.products) {
            setProducts(d.products.slice(0, limit));
            setLoading(false);
            const slider = new Glide(glideEl.current, glideOptions);
            slider.mount();
          }
        })
        .catch((e) => {
          console.error(e)
        });
    } else {
      setLoading(false);
    }
  }, [setProducts, upsellProducts]);

  if (loading) {
    return <p className="loading-widget">loading....</p>;
  }

  let allProducts: any[] = upsellProducts.concat(products);

  // Ensure we don't show items already in the basket
  if (cart && cart.items) {
    const cartItemProductIds = cart.items.map(item => item.product_id);
    allProducts = allProducts.filter(product => cartItemProductIds.indexOf(product.id) === -1);
  }

  // Ensure we don't go over the limit
  allProducts = allProducts.splice(0, limit);

  return (
    allProducts && allProducts.length > 0 ? (
      <section className="cart-recommendations glide" ref={glideEl}>
        <header className="cart-recommendations-header">
          <h2 className="cart-recommendations-header-title heading-2">
            {title}
          </h2>
          <div className="controls glide-arrow-wrapper" data-glide-el="controls">
            <a className="glide__arrow glide__arrow--left" data-glide-dir="<" 
              data-desktop-arrow>
              <span className="visually-hidden">Previous Slide</span>
              <IconBackArrow/>
            </a>
            <a className="glide__arrow glide__arrow--right" data-glide-dir=">" 
              data-desktop-arrow>
              <span className="visually-hidden">Next Slide</span>
              <IconForwardArrow/>
            </a>
          </div>
        </header>
        <div data-glide-el="track" className="glide__track">
          <div className="glide__slides">
            {
              allProducts.map((product, i) =>
                <ProductCard
                  product={product}
                  showSelect={false}
                  fromText={fromText}
                  colourSwatches={colourSwatches}
                  roastText={roastText}
                  tasteText={tasteText}
                  quickAddText={quickAddText}
                  quickAddPlus={quickAddPlus}
                  key={`product-recommendation-${i}`} />
              )
            }
          </div>
        </div>
      </section>
    ) : null
  )
};

export default CartRecommendations
